import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import clsx from "clsx";
import React, { useState } from "react";
import CustomPriceSpan from "../../../../../components/CustomPriceSpan";
import _ from "lodash";
import Helper from "../../../../../utils/Helper";
import * as setOffSelectors from "../../../../../selectors/set-off";
import EmptyItemView from "../../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../../components/LoadingOverlay";
import constants from "../../../../../constants";
import {
  getSetOffStatusText,
  getSetOffStatusValue,
  getSubmittedContractMetadataType,
  getSubmittedContractSubmittedAt,
} from "../../../../../selectors/set-off";
import { Col, Row } from "react-bootstrap";
import * as eWithdrawSelectors from "../../../../../selectors/e-withdraw";
function SubmittedContractItemModal({
  show,
  handleClose,
  data,
  loading,
  onClickDeleteFunction,
  isHideCancel = false,
}) {
  const items = setOffSelectors.getSubmittedContractItems(data);
  const isCancellable = setOffSelectors.getSubmittedContractIsCancellable(data);
  const cancelLink = setOffSelectors.getSubmittedContractCancelLink(data);
  const clientCode = setOffSelectors.getSubmittedContractClientCode(data);
  const currencyCode = setOffSelectors.getSubmittedContractCurrencyCode(data);
  const status = setOffSelectors.getSubmittedContractStatusText(data);
  const transactionAmountOff = setOffSelectors.getSubmittedContractTransactionAmountFullText(data);
  const action = setOffSelectors.getSubmittedContractActionText(data);
  const statusValue = setOffSelectors.getSetOffStatusValue(data);
  const statusText = setOffSelectors.getSetOffStatusText(data);
  const onClickDelete = (url) => {
    onClickDeleteFunction(url);
  };

  const [buttonShow, setButtonShow] = useState(false);
  const limitedItems = 10;
  const listingFilter = buttonShow ? items : _.slice(items, 0, limitedItems);

  return (
    <Modal show={show} onHide={handleClose} centered className="modal-w-900">
      <Modal.Header closeButton>
        <Modal.Title className={"annoucement-modal-title"}>Info</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6} xs={12}>
            <p>
              Action : <span>{action}</span>
            </p>
          </Col>

          <Col md={6} xs={12}>
            <p>Client Code: {clientCode}</p>
          </Col>
          <Col md={6} xs={12}>
            <p>Currency Code: {currencyCode}</p>
          </Col>
          <Col md={6} xs={12}>
            <p>
              Status: {" "}
              <span
                className={clsx("status-span", {
                  ["pending-color"]:  statusValue === constants.STATUS_SUBMITTED || statusValue === constants.STATUS_PENDING,
                  ["successful-color"]:
                    statusValue === constants.STATUS_FILLED,
                  ["error-color"]:
                    statusValue === constants.STATUS_ERROR ||
                    statusValue === constants.STATUS_EXPIRED ||
                    statusValue === constants.STATUS_CANCELLED,
                })}
              >
                {statusText}
              </span>
            </p>
          </Col>
          <Col md={6} xs={12}>
            <p>Transaction Amount: {transactionAmountOff}</p>
          </Col>
        </Row>
        <div className={"responsive-table-border"}>
          <Table responsive="lg">
            <thead>
              <tr className={"custom-table-setoff-styled"}>
                <th style={{ minWidth: 180 }}>Reference No</th>
                <th style={{ minWidth: 120 }}>Stock Code</th>
                <th style={{ minWidth: 180 }}>Stock Name</th>
                <th style={{ minWidth: 140 }}>Submitted Date</th>
                <th style={{ minWidth: 180 }}>Transaction Amount</th>
              </tr>
            </thead>
            <tbody>
            {!_.isEmpty(listingFilter) ? (
                <>
                  {_.map(listingFilter, (item, index) => {
                    const contract = _.get(item, ["contract"], null);
                    const contractReference = setOffSelectors.getSetOffContractReference(contract);
                    const stockCode = setOffSelectors.getSetOffStockCode(contract);
                    const stockName = setOffSelectors.getSetOffStockName(contract);
                    const submittedAt = setOffSelectors.getSubmittedContractSubmittedAt(item);
                    const action = setOffSelectors.getSubmittedContractActionText(item);
                    const transactionAmount =
                        setOffSelectors.getSubmittedContractTransactionAmountFullText(item);

                    return (
                        <tr key={index}>
                          <td>{_.isEmpty(contractReference) ? action : contractReference}</td>
                          <td>{_.isEmpty(stockCode) ? "-" : stockCode}</td>
                          <td>{_.isEmpty(stockName) ? "-" : stockName}</td>
                          <td>{submittedAt}</td>
                          <td>{transactionAmount}</td>
                        </tr>
                    );
                  })}
                  {_.size(data) > limitedItems && (
                      <tr>
                        <td colSpan={5} style={{ textAlign: "center" }}>
                          <button
                              className={clsx("btn custom-button-primary")}
                              style={{ backgroundColor: "#9D7905" }}
                              onClick={() => setButtonShow(!buttonShow)}
                          >
                            {buttonShow ? "View Less" : "View More"}
                          </button>
                        </td>
                      </tr>
                  )}
                </>
            ) : (
                <tr>
                  <td colSpan={5}>
                    <EmptyItemView />
                  </td>
                </tr>
            )}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-end my-3 mr-3">
          <button
            className={clsx("btn custom-button-back")}
            onClick={(e) => {
              e.preventDefault();
              handleClose();
            }}
          >
            Close
          </button>
          {isCancellable ? (
            <button
              className={clsx("btn custom-button-white")}
              onClick={(e) => {
                e.preventDefault();
                onClickDelete(cancelLink);
              }}
              // disabled={!isCancellable}
            >
              Cancel
            </button>
          ) : (
            false
          )}
        </div>
        <LoadingOverlay loading={loading}></LoadingOverlay>
      </Modal.Body>
    </Modal>
  );
}

export default SubmittedContractItemModal;
